/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { TemplateQuoteWarnings_QuoteTemplateFragmentDoc } from './TemplateQuoteWarnings.generated.js';
import { TemplateQuoteStatuses_QuoteTemplateFragmentDoc } from './TemplateQuoteStatuses.generated.js';
import { TemplatesQuoteStatus_TemplateFragmentDoc } from './TemplateQuoteStatus.generated.js';
import { TemplateQuoteTemplateLatestMenu_QuoteTemplateFragmentDoc } from './TemplatesQuoteTemplateLatestMenu.generated.js';
import { TemplateQuoteTemplateVersionMenu_QuoteTemplateFragmentDoc } from './TemplatesQuoteTemplateVersionMenu.generated.js';
export type TemplatesQuoteTemplateSubHeader_QuoteTemplateFragment = { __typename: 'QuoteTemplate', id: string, title: string, customizable: boolean, has3dRoomSnapshot: boolean, resolvedAsReadModelVersionNumber?: number | null, latestPublishedVersionNumber?: number | null, containsUnpublishedChanged: boolean, owningSystemOrganisationId: string, hasAnyPublishedVersion: boolean, accessType: Types.TemplateAccessType, isBinding: boolean, usedInOtherTemplates: boolean, templateSharing?: { __typename: 'TemplateSharing', id: string, latestSharedVersionNumber: number, sharedPublicly: boolean, templateId: string, subscribedToTemplate?: { __typename: 'TemplateSubscription', subscribedVersionNumber: number, updateAvailable: boolean } | null, sharedWithOrganisations: Array<{ __typename: 'Company', id: string, title: string, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }> } | null };

export type TemplatesQuoteTemplateSubHeader_QuoteTemplateItemFragment = { __typename: 'Item', id: string, type: Types.ItemType };

export const TemplatesQuoteTemplateSubHeader_QuoteTemplateFragmentDoc = gql`
    fragment TemplatesQuoteTemplateSubHeader_QuoteTemplate on QuoteTemplate {
  id
  title
  customizable
  has3dRoomSnapshot
  ...TemplateQuoteWarnings_QuoteTemplate
  ...TemplateQuoteStatuses_QuoteTemplate
  ...TemplatesQuoteStatus_Template
  ...TemplateQuoteTemplateLatestMenu_QuoteTemplate
  ...TemplateQuoteTemplateVersionMenu_QuoteTemplate
}
    ${TemplateQuoteWarnings_QuoteTemplateFragmentDoc}
${TemplateQuoteStatuses_QuoteTemplateFragmentDoc}
${TemplatesQuoteStatus_TemplateFragmentDoc}
${TemplateQuoteTemplateLatestMenu_QuoteTemplateFragmentDoc}
${TemplateQuoteTemplateVersionMenu_QuoteTemplateFragmentDoc}`;
export const TemplatesQuoteTemplateSubHeader_QuoteTemplateItemFragmentDoc = gql`
    fragment TemplatesQuoteTemplateSubHeader_QuoteTemplateItem on Item {
  id
  type
}
    `;